import { createLogger } from 'redux-logger';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { thunk } from 'redux-thunk';
import commonReducer from './reducers/commonReducer';
import fundraisingReducer from './reducers/fundraisingReducer';
import paymentReducer from './reducers/paymentReducer';
import dashboardReducer from './reducers/dashboardReducer';
import founderReducer from './reducers/founderReducer';
import activityReducer from './reducers/activityReducer';
import loanReducer from './reducers/loanReducer';
import startupReducer from './reducers/startupReducer';
import helpReducer from './reducers/helpReducer';

const rootReducer = combineReducers({
  commonStore: commonReducer,
  fundraisingStore: fundraisingReducer,
  paymentStore: paymentReducer,
  dashboardStore: dashboardReducer,
  founderStore: founderReducer,
  activityStore: activityReducer,
  loanStore: loanReducer,
  startupStore: startupReducer,
  helpStore: helpReducer,
});

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const middleware = [thunk];

if (import.meta.env.VITE_ENV === 'development') {
  const logger = createLogger({
    diff: true,
    collapsed: true,
    titleFormatter: action => `[action] ${action.type}`,
    level: { prevState: false, nextState: false, error: false },
  });
  middleware.push(logger);
}

const enhancers = composeEnhancers(applyMiddleware(...middleware));

const store = createStore(rootReducer, enhancers);

export default store;
